import { useNavigate } from "react-router-dom";
import "./Legal.css";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-card">
  <button
    type="button"
    className="legal-back-button"
    onClick={() => navigate(-1)}
  >
    ← Back
  </button>

  <h1>Terms of Service</h1>
        <p className="legal-meta">Effective Date: August 8, 2026</p>
        <p className="legal-meta">Last Updated: August 8, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>

          <p>
            These Terms of Service ("Terms") govern your access to and use of
            Bullionaire IQ, bullionaireiq.com, and any related websites,
            applications, software, data, features, tools, content, products,
            subscriptions, communications, and services that reference these
            Terms (collectively, the "Services").
          </p>

          <p>
            In these Terms, "Bullionaire," "we," "our," and "us" refer to
            Bullionaire IQ and the operator of the Services. "You" and "your"
            refer to the individual or entity accessing or using the Services.
          </p>

          <p>
            By creating an account, clicking to accept or agree to these Terms,
            purchasing or subscribing to a Service, or otherwise accessing or
            using the Services after being presented with these Terms, you
            acknowledge that you have read, understood, and agree to be bound by
            these Terms.
          </p>

          <p>
            If you do not agree to these Terms, you may not access or use the
            Services.
          </p>

          <p>
            If you access or use the Services on behalf of a company,
            organization, or other legal entity, you represent and warrant that
            you have authority to bind that entity to these Terms. In that case,
            "you" and "your" also refer to that entity.
          </p>

          <p>
            Please read Section 24 carefully. It contains a binding arbitration
            agreement, class and representative action waiver, and jury trial
            waiver that affect your legal rights.
          </p>
        </section>

        <section>
          <h2>2. Eligibility</h2>

          <p>
            You must be at least eighteen (18) years old and at least the age of
            legal majority in the jurisdiction where you live to create an
            account or use the Services.
          </p>

          <p>
            By using the Services, you represent and warrant that you satisfy
            these eligibility requirements and that your access to and use of
            the Services does not violate any law, regulation, contractual
            restriction, or other legal obligation applicable to you.
          </p>

          <p>
            Certain features, financial products, prediction markets, exchanges,
            contracts, or third-party services referenced by Bullionaire may not
            be legally available to all persons or in all jurisdictions.
            Availability through or reference by Bullionaire does not mean that
            you are legally permitted or eligible to use the applicable
            third-party service or participate in the applicable transaction.
          </p>
        </section>

        <section>
          <h2>3. User Accounts and Account Security</h2>

          <p>
            Certain Services require an account. You agree to provide accurate,
            current, and complete information when creating and maintaining your
            account.
          </p>

          <p>
            You are responsible for maintaining the confidentiality and security
            of your login credentials and for activity conducted through your
            account, except to the extent otherwise required by applicable law.
          </p>

          <p>
            You may not share credentials in a manner that circumvents account,
            subscription, access, or usage restrictions.
          </p>

          <p>
            You agree to notify us promptly at{" "}
            <a href="mailto:info@bullionaireiq.com">
              info@bullionaireiq.com
            </a>{" "}
            if you believe your account has been accessed or used without
            authorization.
          </p>

          <p>
            We may require identity verification, authentication, security
            procedures, or other measures designed to protect the Services and
            our users.
          </p>
        </section>

        <section>
          <h2>4. Description of the Services</h2>

          <p>
            Bullionaire provides technology and information tools that may
            include financial-market data, securities information,
            prediction-market information, analytics, research, calculations,
            rankings, screeners, charts, comparisons, historical information,
            backtesting, alerts, models, estimates, market intelligence, and
            other analytical features.
          </p>

          <p>
            Some Bullionaire features may compare information across multiple
            third-party marketplaces or data sources and may identify apparent
            pricing differences, spreads, discrepancies, or potential
            opportunities.
          </p>

          <p>
            We may add, modify, restrict, suspend, discontinue, replace, or
            remove any Service, feature, data source, integration, market,
            security, calculation, methodology, or functionality at any time,
            subject to applicable law.
          </p>
        </section>

        <section>
          <h2>5. Informational and Educational Purposes Only</h2>

          <p>
            The Services and all information made available through Bullionaire
            are provided for informational, analytical, research, and
            educational purposes only.
          </p>

          <p>
            Nothing available through Bullionaire constitutes or should be
            construed as personalized investment advice, financial advice,
            trading advice, legal advice, tax advice, accounting advice,
            gambling advice, or any other form of professional advice.
          </p>

          <p>
            Nothing on Bullionaire constitutes a recommendation, endorsement,
            solicitation, instruction, offer, or invitation to buy, sell, hold,
            trade, enter into, or participate in any security, commodity,
            derivative, prediction-market contract, wager, investment,
            transaction, strategy, or financial instrument.
          </p>

          <p>
            Bullionaire is not acting as your investment adviser,
            broker-dealer, financial planner, fiduciary, commodity trading
            adviser, futures commission merchant, exchange, prediction-market
            operator, sportsbook, wagering operator, or agent.
          </p>

          <p>
            No fiduciary, advisory, brokerage, agency, partnership, joint
            venture, or other special relationship is created between you and
            Bullionaire merely because you access or use the Services or rely
            upon information provided through them.
          </p>

          <p>
            You are solely responsible for evaluating information presented by
            Bullionaire and for determining whether any investment, trade,
            transaction, prediction-market position, strategy, or other action
            is appropriate for you.
          </p>

          <p>
            You should consult appropriately licensed professional advisers
            regarding financial, investment, legal, tax, regulatory, or other
            professional matters when appropriate.
          </p>
        </section>

        <section>
          <h2>6. Prediction Markets and Third-Party Venues</h2>

          <p>
            Bullionaire may collect, display, organize, analyze, or compare
            information concerning prediction-market contracts offered by
            independent third-party venues.
          </p>

          <p>
            Unless expressly stated otherwise, Bullionaire is independent from
            the prediction markets, exchanges, brokers, data providers, and
            other third-party services whose information may appear through the
            Services.
          </p>

          <p>
            Bullionaire does not create, list, operate, settle, adjudicate,
            custody, guarantee, or control third-party prediction-market
            contracts.
          </p>

          <p>
            Unless expressly offered under a separate written agreement,
            Bullionaire does not place prediction-market orders for you, execute
            trades on your behalf, custody funds or assets intended for
            prediction-market transactions, or control your account at a
            third-party venue.
          </p>

          <p>
            Any transaction you enter into through a third-party venue creates a
            relationship between you and that third party and is governed by the
            third party's own terms, rules, fees, eligibility requirements,
            settlement procedures, privacy policies, and applicable laws.
          </p>

          <p>
            Bullionaire is not responsible for determining whether you are
            eligible to use a particular third-party venue or whether a
            particular transaction is legal in your location.
          </p>

          <p>
            You agree not to use Bullionaire to circumvent geographic
            restrictions, identity-verification requirements, sanctions,
            eligibility requirements, regulatory restrictions, or other access
            controls imposed by a third-party venue or applicable law.
          </p>
        </section>

        <section>
          <h2>7. Cross-Venue Market Matching and Settlement Risk</h2>

          <p>
            Bullionaire may identify contracts offered by different third-party
            venues as matching, comparable, related, economically similar, or
            potentially suitable for cross-venue analysis.
          </p>

          <p>
            Any such classification is an analytical determination made for
            purposes of the Services. It is not a representation, warranty, or
            guarantee that two contracts are legally identical or that the
            contracts will necessarily resolve, settle, cancel, void, or pay out
            in the same manner.
          </p>

          <p>
            Prediction-market contracts may contain differences in wording,
            definitions, deadlines, resolution windows, settlement sources,
            official data providers, cancellation provisions, extraordinary
            event provisions, correction procedures, market rules, discretionary
            authority, or other terms that may affect their outcome.
          </p>

          <p>
            A venue may also amend, suspend, cancel, void, delay, review, or
            otherwise take action regarding a contract in accordance with its
            own rules.
          </p>

          <p>
            The official contract terms, market rules, settlement procedures,
            and final determinations of the applicable third-party venue control
            your transaction with that venue. Bullionaire's labels,
            descriptions, normalization, matching logic, or settlement analysis
            do not override those terms.
          </p>

          <p>
            Before entering any transaction based on a cross-venue comparison,
            you are responsible for independently reviewing the complete
            contract and settlement rules on each applicable venue.
          </p>
        </section>

        <section>
          <h2>8. Arbitrage, Spread, and Opportunity Calculations</h2>

          <p>
            Bullionaire may identify or display apparent arbitrage
            opportunities, pricing discrepancies, spreads, expected returns,
            gross returns, net returns, implied probabilities, or related
            calculations.
          </p>

          <p>
            These calculations are estimates based on information available to
            Bullionaire at a particular point in time and do not constitute a
            guarantee that any opportunity exists or can be successfully
            executed.
          </p>

          <p>
            Market conditions may change within milliseconds or otherwise
            before, during, or after you attempt to act on information displayed
            by Bullionaire.
          </p>

          <p>
            A displayed opportunity may disappear because of changes in price,
            liquidity, order-book depth, available size, trading status, fees,
            venue availability, network conditions, or other factors.
          </p>

          <p>
            Cross-venue transactions may involve execution or "leg" risk. One
            side of a transaction may execute while another side does not, or
            different portions of an order may execute at different prices.
            This may create directional exposure or losses even when the
            original calculation appeared profitable.
          </p>

          <p>
            A displayed gross opportunity may exclude some or all transaction
            costs. A displayed net opportunity may use estimated fees or costs
            and may not account for every expense applicable to you.
          </p>

          <p>
            Actual results may be affected by transaction fees, commissions,
            spreads, slippage, insufficient depth, partial fills, rejected
            orders, funding costs, withdrawal costs, deposit costs, transfer
            costs, blockchain or network fees, currency conversion, taxes, or
            other charges.
          </p>

          <p>
            Bullionaire does not guarantee that an arbitrage opportunity is
            risk-free, executable, profitable, or available in the size shown.
          </p>

          <p>
            You are responsible for confirming prices, available quantity,
            liquidity, fees, settlement terms, and all other transaction details
            directly with each applicable venue before placing an order.
          </p>
        </section>

        <section>
          <h2>9. Market Data, Prices, Volume, and Liquidity</h2>

          <p>
            Bullionaire may receive information from third-party APIs,
            WebSocket feeds, websites, exchanges, prediction markets, financial
            data providers, public records, filings, databases, or other
            sources.
          </p>

          <p>
            Market information may include bids, asks, prices, probabilities,
            market depth, liquidity, volume, open interest, fees, status
            information, historical data, analyst information, corporate data,
            or other information.
          </p>

          <p>
            We strive to provide useful and timely information, but we do not
            warrant or guarantee that market information is accurate, complete,
            current, synchronized, available, or error-free.
          </p>

          <p>
            Information may be delayed, stale, incomplete, duplicated,
            incorrectly transmitted, incorrectly parsed, unavailable, or
            affected by latency, connection failures, rate limits, vendor
            outages, software errors, exchange outages, order-book
            resynchronization, or other technical conditions.
          </p>

          <p>
            Information displayed by Bullionaire may differ from information
            displayed directly by a trading venue or other original source.
            Information displayed by the original venue at the time you transact
            should be independently reviewed before you act.
          </p>

          <p>
            Volume, liquidity, historical performance, and other metrics from
            different providers or venues may be calculated using different
            methodologies and may not be directly comparable.
          </p>
        </section>

        <section>
          <h2>10. Models, Analytics, Backtests, and Estimates</h2>

          <p>
            Bullionaire may provide proprietary or third-party models,
            algorithms, rankings, scores, forecasts, estimates, simulations,
            backtests, historical analyses, correlations, signals, or other
            analytical outputs.
          </p>

          <p>
            These outputs may rely on assumptions, historical information,
            estimates, statistical methods, third-party information, and
            automated calculations that may be inaccurate or may fail to
            reflect future conditions.
          </p>

          <p>
            Backtested, simulated, hypothetical, modeled, or historical results
            do not represent actual future results and should not be interpreted
            as guarantees of future performance.
          </p>

          <p>
            Past performance of any security, market, strategy, analyst,
            prediction market, portfolio, model, or other asset or methodology
            does not guarantee future performance.
          </p>
        </section>

        <section>
          <h2>11. Alerts, Notifications, and Time-Sensitive Information</h2>

          <p>
            Bullionaire may offer alerts, notifications, watchlists, opportunity
            notifications, or other time-sensitive features.
          </p>

          <p>
            We do not guarantee that any alert or notification will be delivered,
            delivered on time, received, viewed, or remain accurate when
            received.
          </p>

          <p>
            Alerts may be delayed or prevented by network conditions, email
            providers, push-notification systems, telecommunications providers,
            device settings, third-party outages, service interruptions, or
            other circumstances outside Bullionaire's control.
          </p>

          <p>
            You should not rely on Bullionaire alerts as your sole method of
            monitoring a market, investment, position, deadline, or financial
            risk.
          </p>
        </section>

        <section>
          <h2>12. Third-Party Services, Links, and Content</h2>

          <p>
            The Services may contain links to, integrations with, information
            from, or references to third-party websites, applications,
            exchanges, prediction markets, financial institutions, payment
            processors, data providers, authentication providers, or other
            services.
          </p>

          <p>
            Bullionaire does not control third-party services and does not
            warrant or endorse their availability, accuracy, security,
            legality, reliability, financial condition, content, products,
            services, or conduct.
          </p>

          <p>
            Your use of a third-party service is at your own risk and is
            governed by the applicable third party's terms and policies.
          </p>

          <p>
            Bullionaire shall not be responsible for losses arising from a
            third-party provider's outage, error, delay, data failure, security
            incident, market suspension, insolvency, account restriction,
            transaction rejection, contract settlement, rule interpretation,
            cancellation, or other act or omission.
          </p>
        </section>

        <section>
          <h2>13. Your Financial and Trading Decisions</h2>

          <p>
            You retain sole responsibility for every investment, trade,
            prediction-market position, financial transaction, or other decision
            you make.
          </p>

          <p>
            You are responsible for conducting your own investigation and due
            diligence and evaluating your financial circumstances, objectives,
            experience, risk tolerance, tax circumstances, and legal
            restrictions.
          </p>

          <p>
            You acknowledge that investing, trading, speculation,
            prediction-market participation, and arbitrage can involve
            significant risk, including the risk of losing some or all amounts
            committed.
          </p>

          <p>
            You should never enter a transaction solely because an opportunity,
            ranking, score, comparison, analyst estimate, signal, probability,
            or calculation appears on Bullionaire.
          </p>
        </section>

        <section>
          <h2>14. Compliance With Laws</h2>

          <p>
            You are responsible for ensuring that your access to and use of the
            Services complies with all laws, regulations, rules, contractual
            obligations, licensing requirements, tax requirements, and
            geographic restrictions applicable to you.
          </p>

          <p>
            Laws concerning securities, commodities, derivatives,
            prediction-market contracts, gaming, wagering, financial services,
            taxation, sanctions, and online services vary by jurisdiction and
            may change over time.
          </p>

          <p>
            Bullionaire's display of a market, contract, security, venue,
            service, or potential opportunity does not constitute a
            representation that your participation is legal or permitted.
          </p>
        </section>

        <section>
          <h2>15. Limited License</h2>

          <p>
            Subject to your compliance with these Terms, Bullionaire grants you
            a limited, personal, revocable, non-exclusive, non-transferable, and
            non-sublicensable right to access and use the Services for your own
            lawful personal or internal business purposes.
          </p>

          <p>
            This license does not transfer ownership of the Services or any
            Bullionaire intellectual property to you.
          </p>
        </section>

        <section>
          <h2>16. Acceptable Use and Prohibited Conduct</h2>

          <p>You agree not to, directly or indirectly:</p>

          <ul>
            <li>
              Use the Services for any unlawful, fraudulent, deceptive,
              abusive, or malicious purpose
            </li>

            <li>
              Attempt to gain unauthorized access to the Services, another
              account, Bullionaire systems, databases, servers, APIs, or
              networks
            </li>

            <li>
              Interfere with, disrupt, damage, overload, disable, or impair the
              operation or security of the Services
            </li>

            <li>
              Circumvent authentication, subscription, usage, geographic,
              security, access-control, or technical restrictions
            </li>

            <li>
              Use bots, scrapers, crawlers, automated extraction systems, or
              similar technologies to access, copy, harvest, or extract
              substantial portions of the Services except with our prior
              written authorization or as otherwise permitted by applicable law
            </li>

            <li>
              Copy, reproduce, republish, sell, license, sublicense,
              redistribute, syndicate, commercially exploit, or create a
              competing data service using Bullionaire content except as
              expressly permitted by us
            </li>

            <li>
              Reverse engineer, decompile, disassemble, or attempt to derive
              source code or non-public algorithms from the Services except to
              the limited extent such restriction is prohibited by applicable
              law
            </li>

            <li>
              Introduce malware, viruses, malicious code, or other harmful
              technology into the Services
            </li>

            <li>
              Impersonate another person or entity or misrepresent your
              affiliation with another person or entity
            </li>

            <li>
              Use the Services in a manner that violates the intellectual
              property, privacy, contractual, or other legal rights of another
              person
            </li>

            <li>
              Attempt to manipulate Bullionaire data, systems, metrics,
              rankings, usage limits, or platform operation
            </li>

            <li>
              Use Bullionaire to evade or circumvent restrictions imposed by a
              third-party trading venue, prediction market, exchange, financial
              institution, regulator, or governmental authority
            </li>
          </ul>
        </section>

        <section>
          <h2>17. Intellectual Property</h2>

          <p>
            The Services and their original content, design, branding,
            trademarks, logos, software, source code, object code, databases,
            interfaces, graphics, layouts, models, calculations, methodologies,
            compilations, analytics, and other materials are owned by or
            licensed to Bullionaire and are protected by applicable
            intellectual property and other laws.
          </p>

          <p>
            Except for the limited license expressly granted in these Terms, no
            rights in Bullionaire's intellectual property are granted to you by
            implication, estoppel, or otherwise.
          </p>

          <p>
            Third-party names, trademarks, logos, data, and other intellectual
            property displayed through the Services remain the property of
            their respective owners.
          </p>

          <p>
            Reference to a third-party company, market, exchange, product, or
            service does not necessarily imply sponsorship, endorsement,
            partnership, or affiliation.
          </p>
        </section>

        <section>
          <h2>18. Feedback</h2>

          <p>
            If you voluntarily provide suggestions, ideas, recommendations,
            comments, feature requests, or other feedback regarding Bullionaire
            ("Feedback"), you grant Bullionaire a worldwide, perpetual,
            irrevocable, royalty-free, transferable, and sublicensable right to
            use, reproduce, modify, distribute, commercialize, and otherwise
            exploit that Feedback without restriction or obligation to
            compensate you.
          </p>

          <p>
            This provision does not transfer ownership of your personal
            information, which is handled in accordance with our Privacy Policy
            and applicable law.
          </p>
        </section>

        <section>
          <h2>19. Paid Services, Subscriptions, and Billing</h2>

          <p>
            Bullionaire may offer free and paid plans, subscriptions,
            promotional access, trials, premium features, or other paid
            Services.
          </p>

          <p>
            Prices, billing frequency, included features, subscription periods,
            renewal terms, and any other material purchase terms will be
            disclosed to you at or before purchase.
          </p>

          <p>
            If you purchase a recurring subscription, you authorize Bullionaire
            and its payment providers to charge the applicable payment method
            for recurring subscription fees and applicable taxes in accordance
            with the terms presented to you at checkout, until you cancel or
            the subscription is otherwise terminated.
          </p>

          <p>
            You may cancel a subscription using the cancellation method made
            available by Bullionaire. Unless otherwise stated at purchase,
            cancellation generally prevents future renewal and does not
            retroactively cancel the current paid subscription period.
          </p>

          <p>
            Except as required by applicable law or expressly stated in the
            applicable purchase terms, amounts already paid are non-refundable.
          </p>

          <p>
            We may change subscription pricing or plan features prospectively.
            Where required by applicable law, we will provide notice before a
            pricing change becomes effective for an existing recurring
            subscription.
          </p>

          <p>
            You are responsible for applicable taxes, duties, or governmental
            charges associated with your purchase, except taxes imposed on
            Bullionaire's own income.
          </p>
        </section>

        <section>
          <h2>20. Privacy</h2>

          <p>
            Our collection, use, disclosure, and protection of personal
            information are described in our Privacy Policy.
          </p>

          <p>
            By using the Services, you acknowledge that you have had an
            opportunity to review the Privacy Policy.
          </p>

          <p>
            The Privacy Policy may be updated separately from these Terms as
            described in that policy and as permitted by applicable law.
          </p>
        </section>

        <section>
          <h2>21. Electronic Communications and Notices</h2>

          <p>
            By creating an account or using the Services, you agree that we may
            provide transactional, administrative, security, legal, and
            account-related communications electronically, including by email,
            through your account, or through notices displayed on the Services.
          </p>

          <p>
            You are responsible for maintaining a current email address
            associated with your account.
          </p>

          <p>
            Electronic notices and records may satisfy legal requirements that
            communications be provided in writing to the extent permitted by
            applicable law.
          </p>
        </section>

        <section>
          <h2>22. Suspension, Restriction, and Termination</h2>

          <p>
            To the fullest extent permitted by applicable law, Bullionaire may
            suspend, restrict, disable, or terminate your account or access to
            some or all of the Services if we reasonably believe that:
          </p>

          <ul>
            <li>You have violated these Terms</li>
            <li>
              Your account or activity presents a security, fraud, legal, or
              operational risk
            </li>
            <li>
              You have engaged in unlawful, abusive, deceptive, or harmful
              conduct
            </li>
            <li>
              Suspension or termination is necessary to comply with applicable
              law, legal process, or a governmental request
            </li>
            <li>
              Your use materially interferes with the Services or other users
            </li>
            <li>
              A third-party provider or integration necessary for the Services
              becomes unavailable
            </li>
          </ul>

          <p>
            We may also discontinue all or part of the Services or cease
            operating Bullionaire, subject to any obligations imposed by
            applicable law.
          </p>

          <p>
            Upon termination, your right to access and use the affected Services
            will cease.
          </p>

          <p>
            Provisions that by their nature should survive termination will
            survive, including provisions concerning intellectual property,
            payment obligations, disclaimers, limitations of liability,
            indemnification, dispute resolution, governing law, and other
            provisions necessary to give effect to these Terms.
          </p>
        </section>

        <section>
          <h2>23. Disclaimer of Warranties</h2>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES
              AND ALL DATA, INFORMATION, CONTENT, SOFTWARE, ANALYTICS,
              CALCULATIONS, ALERTS, MODELS, SIGNALS, PRICES, PROBABILITIES,
              MARKET COMPARISONS, AND OTHER MATERIALS AVAILABLE THROUGH
              BULLIONAIRE ARE PROVIDED "AS IS," "AS AVAILABLE," AND "WITH ALL
              FAULTS."
            </strong>
          </p>

          <p>
            <strong>
              BULLIONAIRE DISCLAIMS, TO THE FULLEST EXTENT PERMITTED BY LAW,
              ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY,
              OR OTHERWISE, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, ACCURACY,
              COMPLETENESS, RELIABILITY, AVAILABILITY, SECURITY, TIMELINESS,
              QUIET ENJOYMENT, AND RESULTS.
            </strong>
          </p>

          <p>
            <strong>
              BULLIONAIRE DOES NOT WARRANT THAT THE SERVICES WILL BE
              UNINTERRUPTED, ERROR-FREE, SECURE, CURRENT, COMPLETE, OR FREE OF
              HARMFUL COMPONENTS OR THAT ANY DEFECT, ERROR, INTERRUPTION, DATA
              ISSUE, OR INACCURACY WILL BE IDENTIFIED OR CORRECTED.
            </strong>
          </p>

          <p>
            <strong>
              BULLIONAIRE MAKES NO WARRANTY REGARDING THE ACCURACY OR
              AVAILABILITY OF ANY THIRD-PARTY MARKET DATA, PRICE, ORDER BOOK,
              VOLUME FIGURE, LIQUIDITY FIGURE, MARKET STATUS, CONTRACT MATCH,
              SETTLEMENT DETERMINATION, FEE ESTIMATE, ANALYST INFORMATION, OR
              OTHER THIRD-PARTY INFORMATION.
            </strong>
          </p>

          <p>
            <strong>
              BULLIONAIRE DOES NOT WARRANT OR GUARANTEE ANY PARTICULAR
              INVESTMENT, TRADING, FINANCIAL, PREDICTION-MARKET, ARBITRAGE, OR
              OTHER RESULT.
            </strong>
          </p>

          <p>
            Some jurisdictions do not permit the exclusion of certain
            warranties. In those jurisdictions, the exclusions above apply only
            to the maximum extent permitted by applicable law.
          </p>
        </section>

        <section>
          <h2>24. Limitation of Liability</h2>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, BULLIONAIRE
              AND ITS AFFILIATES, OWNERS, OFFICERS, DIRECTORS, EMPLOYEES,
              CONTRACTORS, AGENTS, LICENSORS, DATA PROVIDERS, AND SERVICE
              PROVIDERS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
              SPECIAL, EXEMPLARY, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING
              OUT OF OR RELATING TO THE SERVICES OR THESE TERMS.
            </strong>
          </p>

          <p>
            <strong>
              THIS EXCLUSION INCLUDES, WITHOUT LIMITATION, LOSS OF PROFITS,
              REVENUE, BUSINESS, BUSINESS OPPORTUNITIES, INVESTMENT VALUE,
              TRADING PROFITS, EXPECTED RETURNS, DATA, USE, GOODWILL, OR OTHER
              INTANGIBLE LOSSES, EVEN IF BULLIONAIRE HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES.
            </strong>
          </p>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY LAW, BULLIONAIRE SHALL NOT BE
              LIABLE FOR LOSSES ARISING OUT OF OR RELATING TO INVESTMENT
              DECISIONS, TRADES, PREDICTION-MARKET TRANSACTIONS, FAILED OR
              MISSED ARBITRAGE OPPORTUNITIES, PARTIAL FILLS, FAILED EXECUTION,
              LEG RISK, SLIPPAGE, PRICE MOVEMENTS, INSUFFICIENT LIQUIDITY,
              MARKET DEPTH, FEES, DELAYED OR INCORRECT DATA, THIRD-PARTY DATA,
              CONTRACT MATCHING, DIFFERING SETTLEMENT RESULTS, MARKET
              CANCELLATIONS, MARKET SUSPENSIONS, THIRD-PARTY OUTAGES, API
              FAILURES, NETWORK FAILURES, SERVICE INTERRUPTIONS, OR RELIANCE
              UPON INFORMATION PROVIDED THROUGH THE SERVICES.
            </strong>
          </p>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE TOTAL
              AGGREGATE LIABILITY OF BULLIONAIRE AND ITS AFFILIATES, OWNERS,
              OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AND AGENTS FOR ALL
              CLAIMS ARISING OUT OF OR RELATING TO THE SERVICES OR THESE TERMS
              SHALL NOT EXCEED THE GREATER OF: (A) THE TOTAL AMOUNT YOU PAID
              DIRECTLY TO BULLIONAIRE FOR THE SERVICES DURING THE TWELVE (12)
              MONTHS IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM;
              OR (B) ONE HUNDRED U.S. DOLLARS ($100).
            </strong>
          </p>

          <p>
            The limitations in this Section apply regardless of the form or
            theory of liability, whether based in contract, tort, negligence,
            strict liability, statute, warranty, or otherwise.
          </p>

          <p>
            Nothing in these Terms excludes or limits liability to the extent
            that such liability cannot lawfully be excluded or limited under
            applicable law.
          </p>
        </section>

        <section>
          <h2>25. Indemnification</h2>

          <p>
            To the fullest extent permitted by applicable law, you agree to
            defend, indemnify, and hold harmless Bullionaire and its affiliates,
            owners, officers, directors, employees, contractors, agents,
            licensors, and service providers from and against third-party
            claims, actions, proceedings, liabilities, damages, judgments,
            losses, costs, and reasonable attorneys' fees to the extent arising
            out of or relating to:
          </p>

          <ul>
            <li>Your material violation of these Terms</li>

            <li>Your unlawful or unauthorized use of the Services</li>

            <li>
              Your violation of applicable law or the legal rights of another
              person or entity
            </li>

            <li>
              Fraudulent, abusive, malicious, or intentionally wrongful conduct
              by you
            </li>

            <li>
              Your unauthorized use of a third-party account, market, exchange,
              venue, data source, or service
            </li>
          </ul>

          <p>
            Bullionaire reserves the right, at its expense, to assume exclusive
            control of the defense of a matter otherwise subject to
            indemnification by you. If we do so, you agree to reasonably
            cooperate with the defense.
          </p>

          <p>
            You will not be required to indemnify Bullionaire for liability to
            the extent caused by conduct for which indemnification cannot
            lawfully be required.
          </p>
        </section>

        <section>
          <h2>26. Binding Arbitration and Dispute Resolution</h2>

          <p>
            <strong>
              PLEASE READ THIS SECTION CAREFULLY. EXCEPT FOR LIMITED EXCEPTIONS,
              IT REQUIRES YOU AND BULLIONAIRE TO RESOLVE DISPUTES THROUGH
              INDIVIDUAL BINDING ARBITRATION RATHER THAN IN COURT. IT ALSO
              CONTAINS A CLASS ACTION WAIVER AND JURY TRIAL WAIVER.
            </strong>
          </p>

          <h3>26.1 Informal Dispute Resolution</h3>

          <p>
            Before initiating arbitration, you and Bullionaire agree to make a
            good-faith effort to resolve the dispute informally.
          </p>

          <p>
            A party initiating a dispute must provide the other party with a
            written notice describing the dispute and requested relief.
          </p>

          <p>
            Notices to Bullionaire must be sent to{" "}
            <a href="mailto:info@bullionaireiq.com">
              info@bullionaireiq.com
            </a>
            . Your notice must include your full name, the email address
            associated with your Bullionaire account, a reasonable description
            of the dispute, the relevant facts, and the relief you are
            requesting.
          </p>

          <p>
            Bullionaire may send a dispute notice to the email address
            associated with your account.
          </p>

          <p>
            Neither party may initiate arbitration until thirty (30) days after
            the other party receives a compliant notice of dispute, unless the
            parties resolve the dispute sooner or applicable law requires
            otherwise.
          </p>

          <p>
            The parties agree to participate personally and in good faith in
            this informal resolution process.
          </p>

          <h3>26.2 Agreement to Arbitrate</h3>

          <p>
            Except as expressly provided below, you and Bullionaire agree that
            any dispute, claim, or controversy arising out of or relating to
            these Terms, the Privacy Policy, the Services, your account, your
            relationship with Bullionaire, communications between you and
            Bullionaire, or any transaction or interaction involving the
            Services shall be resolved exclusively through final and binding
            individual arbitration rather than in court.
          </p>

          <p>
            This agreement applies to claims based on contract, tort, statute,
            fraud, misrepresentation, negligence, regulation, common law,
            equity, or any other legal theory, including claims arising before
            you accepted these Terms to the extent permitted by applicable law.
          </p>

          <h3>26.3 Federal Arbitration Act</h3>

          <p>
            The parties agree that these Terms involve interstate commerce and
            that the Federal Arbitration Act ("FAA"), 9 U.S.C. §§ 1–16, governs
            the interpretation, applicability, and enforcement of this
            arbitration agreement to the fullest extent applicable.
          </p>

          <h3>26.4 Arbitration Administrator and Rules</h3>

          <p>
            Arbitration shall be administered by the American Arbitration
            Association ("AAA") under the AAA Consumer Arbitration Rules and
            Mediation Procedures in effect when the arbitration is initiated,
            together with any other AAA rules that properly apply to the
            proceeding, as modified by these Terms.
          </p>

          <p>
            If there is a conflict between these Terms and the applicable AAA
            rules, these Terms will control to the extent permitted by
            applicable law and the AAA's applicable due-process requirements.
          </p>

          <p>
            The arbitration will be conducted by a neutral arbitrator selected
            in accordance with the applicable AAA rules.
          </p>

          <h3>26.5 Arbitration Fees</h3>

          <p>
            Arbitration fees and costs shall be allocated in accordance with the
            applicable AAA Consumer Arbitration Rules, fee schedules, and
            applicable law.
          </p>

          <p>
            Bullionaire will pay arbitration fees and arbitrator compensation
            that the applicable AAA rules or applicable law require Bullionaire
            to pay.
          </p>

          <p>
            Each party will ordinarily be responsible for its own attorneys'
            fees and expenses unless an applicable statute, these Terms, or the
            arbitrator permits or requires an award of attorneys' fees or costs.
          </p>

          <h3>26.6 Arbitration Procedure and Hearing</h3>

          <p>
            Arbitration may proceed through written submissions, telephone,
            video conference, virtual hearing, or an in-person hearing as
            provided by the applicable AAA rules or determined by the arbitrator
            consistent with applicable law.
          </p>

          <p>
            The location and manner of any hearing will be determined in
            accordance with the applicable AAA Consumer Arbitration Rules and
            applicable law.
          </p>

          <p>
            The arbitrator may award the same individual remedies and relief
            that would be available to the individual claimant in court to the
            extent authorized by applicable law.
          </p>

          <p>
            The arbitrator shall issue a written award sufficient to explain the
            essential findings and conclusions on which the award is based when
            required by the applicable rules or law.
          </p>

          <h3>26.7 Authority of the Arbitrator</h3>

          <p>
            Except as otherwise expressly provided in this Section or required
            by applicable law, the arbitrator shall have authority to resolve
            disputes concerning the interpretation, applicability,
            enforceability, or formation of these Terms and this arbitration
            agreement.
          </p>

          <p>
            Questions concerning the enforceability of the Class Action and
            Representative Action Waiver below shall be determined by a court of
            competent jurisdiction to the extent required by applicable law.
          </p>

          <h3>26.8 Small Claims Court</h3>

          <p>
            Notwithstanding the arbitration agreement, either party may bring an
            individual claim in a court of competent small claims jurisdiction
            if the claim qualifies, remains solely on an individual and
            non-representative basis, and otherwise satisfies the requirements
            of that court.
          </p>

          <h3>26.9 Temporary or Emergency Relief</h3>

          <p>
            Nothing in this Section prevents either party from requesting
            temporary or emergency injunctive relief from a court of competent
            jurisdiction when necessary to preserve the status quo, prevent
            imminent harm, protect account or system security, or preserve the
            effectiveness of the arbitration process while arbitration is
            pending.
          </p>

          <p>
            Seeking such temporary relief does not waive the right or obligation
            to arbitrate the underlying dispute.
          </p>

          <h3>26.10 Class Action and Representative Action Waiver</h3>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AND
              BULLIONAIRE AGREE THAT EACH PARTY MAY ASSERT CLAIMS AGAINST THE
              OTHER ONLY IN AN INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF,
              CLAIMANT, CLASS MEMBER, OR REPRESENTATIVE IN ANY PURPORTED CLASS,
              COLLECTIVE, CONSOLIDATED, OR REPRESENTATIVE ACTION OR PROCEEDING.
            </strong>
          </p>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NO ARBITRATOR
              MAY CONSOLIDATE OR JOIN THE CLAIMS OF DIFFERENT INDIVIDUALS FOR
              PURPOSES OF A SINGLE MERITS DETERMINATION OR PRESIDE OVER A CLASS,
              COLLECTIVE, OR REPRESENTATIVE PROCEEDING WITHOUT THE EXPRESS
              WRITTEN CONSENT OF BOTH YOU AND BULLIONAIRE.
            </strong>
          </p>

          <p>
            This provision does not prevent administrative coordination of
            individually filed arbitration demands where coordination is
            permitted or required by applicable AAA rules, provided that each
            claimant's substantive claim remains individual unless applicable
            law requires otherwise.
          </p>

          <h3>26.11 Mass Arbitration</h3>

          <p>
            If multiple similar arbitration demands are filed and the AAA
            determines that its Mass Arbitration Supplementary Rules or
            successor rules apply, those rules will govern the administration
            of the proceedings to the extent consistent with these Terms and
            applicable law.
          </p>

          <p>
            Application of mass-arbitration procedures does not itself convert
            individual claims into a class action, collective action, or
            representative merits proceeding.
          </p>

          <h3>26.12 Waiver of Jury Trial</h3>

          <p>
            <strong>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AND
              BULLIONAIRE EACH KNOWINGLY AND VOLUNTARILY WAIVE ANY
              CONSTITUTIONAL OR STATUTORY RIGHT TO HAVE A DISPUTE COVERED BY
              THIS ARBITRATION AGREEMENT DECIDED IN COURT BEFORE A JUDGE OR
              JURY.
            </strong>
          </p>

          <h3>26.13 Arbitration Opt-Out Right</h3>

          <p>
            You may opt out of this arbitration agreement by sending a written
            opt-out notice to{" "}
            <a href="mailto:info@bullionaireiq.com">
              info@bullionaireiq.com
            </a>{" "}
            within thirty (30) days after the date you first accept a version
            of these Terms containing this arbitration agreement.
          </p>

          <p>Your opt-out notice must include:</p>

          <ul>
            <li>Your full legal name</li>
            <li>The email address associated with your Bullionaire account</li>
            <li>
              A clear statement that you are opting out of the Bullionaire
              arbitration agreement
            </li>
          </ul>

          <p>
            An opt-out applies only to the arbitration agreement. All other
            provisions of these Terms remain in effect.
          </p>

          <p>
            Bullionaire will not terminate your account solely because you
            properly exercise this arbitration opt-out right.
          </p>

          <h3>26.14 Changes to the Arbitration Agreement</h3>

          <p>
            If Bullionaire makes a material change to this arbitration agreement
            after you first accept it, we will provide notice as required by
            applicable law.
          </p>

          <p>
            A material change to the arbitration agreement will not apply
            retroactively to a dispute for which either party had already
            provided a valid written notice of dispute before the effective date
            of the change.
          </p>

          <p>
            Where required to preserve enforceability under applicable law, you
            may reject a material future change to the arbitration agreement by
            sending written notice to{" "}
            <a href="mailto:info@bullionaireiq.com">
              info@bullionaireiq.com
            </a>{" "}
            within thirty (30) days after receiving notice of the change. In
            that circumstance, the arbitration provision you most recently
            accepted before the rejected change will continue to govern to the
            extent permitted by law.
          </p>

          <h3>26.15 Severability of Arbitration Provisions</h3>

          <p>
            Except as otherwise required by applicable law, if any portion of
            this arbitration agreement is determined to be invalid or
            unenforceable, that portion shall be severed or limited to the
            minimum extent necessary and the remainder of this arbitration
            agreement shall remain in effect.
          </p>

          <p>
            If applicable law prohibits arbitration or waiver of a particular
            form of relief, including a form of public injunctive relief that
            cannot lawfully be waived, the request for that relief shall be
            treated as required by applicable law while the remainder of the
            dispute remains subject to arbitration to the fullest extent
            permitted.
          </p>
        </section>

        <section>
          <h2>27. Governing Law</h2>

          <p>
            The arbitration agreement in Section 26 is governed by the Federal
            Arbitration Act to the extent applicable.
          </p>

          <p>
            Except to the extent governed by the Federal Arbitration Act,
            preempted by federal law, or subject to mandatory law that cannot
            lawfully be waived, these Terms and any dispute arising out of or
            relating to Bullionaire shall be governed by and construed in
            accordance with the laws of the State of Texas, United States,
            without regard to conflict-of-law principles.
          </p>
        </section>

        <section>
          <h2>28. Court Proceedings and Venue</h2>

          <p>
            For any dispute or claim that is not required to be arbitrated under
            Section 26 and that may properly be resolved in court, you and
            Bullionaire consent to the personal jurisdiction of the appropriate
            state or federal courts located in the State of Texas, subject to
            any mandatory jurisdictional or venue rights that cannot lawfully be
            waived.
          </p>

          <p>
            Nothing in this Section limits either party's ability to enforce an
            arbitration award or seek relief in another jurisdiction when
            necessary for enforcement and permitted by applicable law.
          </p>
        </section>

        <section>
          <h2>29. Changes to These Terms</h2>

          <p>
            We may modify these Terms from time to time to reflect changes to
            the Services, our business, applicable laws, security requirements,
            dispute-resolution procedures, or other operational needs.
          </p>

          <p>
            When we update these Terms, we will revise the "Last Updated" date
            above.
          </p>

          <p>
            If a change is material, we may provide additional notice through
            the Services, by email, during account login, through an
            account-level notice, or by another reasonable method as required
            by applicable law.
          </p>

          <p>
            Where applicable law requires affirmative consent to a change, we
            will request that consent.
          </p>

          <p>
            Your continued use of the Services after updated Terms become
            effective constitutes acceptance of the updated Terms to the extent
            permitted by applicable law.
          </p>

          <p>
            Changes to the arbitration agreement are additionally governed by
            Section 26.14.
          </p>
        </section>

        <section>
          <h2>30. Force Majeure</h2>

          <p>
            To the fullest extent permitted by law, Bullionaire will not be
            responsible for delay, interruption, or failure to perform caused by
            circumstances beyond our reasonable control.
          </p>

          <p>
            Such circumstances may include natural disasters, severe weather,
            fires, floods, epidemics, pandemics, war, terrorism, civil unrest,
            governmental action, labor disputes, utility failures, internet or
            telecommunications failures, cyberattacks, cloud-provider outages,
            third-party API failures, exchange or market outages, power
            failures, blockchain or network disruptions, or other comparable
            events outside our reasonable control.
          </p>
        </section>

        <section>
          <h2>31. Assignment</h2>

          <p>
            You may not assign or transfer these Terms or your rights or
            obligations under them without Bullionaire's prior written consent.
          </p>

          <p>
            Bullionaire may assign or transfer these Terms in connection with a
            merger, acquisition, financing, corporate reorganization, sale of
            assets, change of control, or transfer of all or a substantial
            portion of the business associated with the Services, or as
            otherwise permitted by applicable law.
          </p>
        </section>

        <section>
          <h2>32. Severability</h2>

          <p>
            Except where a different severability rule is expressly stated in
            the arbitration provisions, if any provision of these Terms is held
            unlawful, invalid, or unenforceable, that provision shall be
            enforced to the maximum extent permitted by law or severed to the
            minimum extent necessary.
          </p>

          <p>
            The remaining provisions will continue in full force and effect.
          </p>
        </section>

        <section>
          <h2>33. No Waiver</h2>

          <p>
            Bullionaire's failure or delay in exercising or enforcing any right
            or provision of these Terms does not constitute a waiver of that
            right or provision.
          </p>

          <p>
            A waiver on one occasion does not constitute a waiver on any other
            occasion.
          </p>
        </section>

        <section>
          <h2>34. Entire Agreement</h2>

          <p>
            These Terms, together with any additional terms expressly
            incorporated or presented in connection with a particular Service,
            constitute the entire agreement between you and Bullionaire
            concerning your use of the Services and supersede prior agreements,
            understandings, or communications concerning the same subject
            matter.
          </p>

          <p>
            Additional terms presented for a particular feature, subscription,
            promotion, or service may supplement these Terms. If those
            additional terms conflict with these Terms, the additional terms
            will control solely with respect to the applicable feature,
            subscription, promotion, or service unless they state otherwise.
          </p>
        </section>

        <section>
          <h2>35. Interpretation</h2>

          <p>
            Section titles and headings are provided for convenience only and
            do not affect the interpretation of these Terms.
          </p>

          <p>
            Words such as "including" and "include" mean "including without
            limitation" unless the context requires otherwise.
          </p>

          <p>
            These Terms will not be interpreted against either party solely
            because that party drafted or proposed a provision.
          </p>
        </section>

        <section>
          <h2>36. Contact Information</h2>

          <p>
            If you have questions about these Terms, need to provide a legal
            notice, or wish to contact Bullionaire regarding these Terms, you
            may contact us at{" "}
            <a href="mailto:info@bullionaireiq.com">
              info@bullionaireiq.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}